import React from 'react';
import CookiePolicyLink from '../cookiePolicyLink';
import { COOKIE_TEXT } from '../text';

function CookieBar({ cookiePolicyUrl, onAccept, onReject, onManage }) {
    const { bar } = COOKIE_TEXT;

    return (
        <div className="cc-bar" role="region" aria-label={bar.label}>
            <div className="cc-bar__inner">
                <p className="cc-bar__text">
                    {bar.intro} <CookiePolicyLink url={cookiePolicyUrl} />.
                </p>
                <div className="cc-bar__actions">
                    <button type="button" className="cc-button cc-button--primary" onClick={onAccept}>
                        {bar.accept}
                    </button>
                    <button type="button" className="cc-button cc-button--primary" onClick={onReject}>
                        {bar.reject}
                    </button>
                    <button type="button" className="cc-button cc-button--outline" onClick={onManage}>
                        {bar.manage}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CookieBar;
